export default function countWords(str) {
  if (typeof str !== 'string') {
    throw new TypeError('expected a string');
  }
  const cleanStr = str.replace(/(<([^>]+)>)/ig, '').trim();
  return cleanStr ? cleanStr.split(/\s+/).length : 0;
}

export function getVisualBuilderScriptsWordCount(visualBuilderScripts) {
  const words = visualBuilderScripts ?
  visualBuilderScripts.map(({ script }) => script) :
  [];
  return words.reduce((total, str) => total + countWords(str), 0);
}